"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEpochSecondsToDate = void 0;
const validations_1 = require("./validations");
function parseEpochSecondsToDate(value) {
    // @ts-ignore
    const epochSeconds = parseInt(value);
    return isNaN(epochSeconds) ? null : epochSecondsToDate(epochSeconds);
}
exports.parseEpochSecondsToDate = parseEpochSecondsToDate;
function epochSecondsToDate(seconds) {
    if (seconds instanceof Date) {
        return new Date(seconds);
    }
    if (!(0, validations_1.isNumber)(seconds)) {
        return null;
    }
    return new Date(seconds * 1000);
}
exports.default = epochSecondsToDate;
